// extracted by mini-css-extract-plugin
module.exports = {"wrap":"footer_wrap__1La5y","left":"footer_left__6CGtF","right":"footer_right__5FgMG","item":"footer_item__PztHD"};